module.exports = __webpack_public_path__ + "img/binary_from.32c3fd12.png";